module.exports = __webpack_public_path__ + "static/img/wise-map.7eb9211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wise-map.png
// module id = 1244
// module chunks = 62